module.exports = __webpack_public_path__ + "6897dac333c94a2ddf667434f99c42d7.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-aima.png
// module id = 600
// module chunks = 30